import { Lead } from '@opanuj/shared/types';
import { ref } from 'firebase/database';
import { useDatabase } from './useDatabase';
import { useListVals } from 'react-firebase-hooks/database';
import { withDefaultList } from './defaults';

export const useLeadsList = (): [Lead[], boolean, Error | undefined] => {
	const database = useDatabase();
	const [leads, loading, error] = useListVals<Lead>(ref(database, 'leads'), { keyField: 'id' });
	return [withDefaultList(leads), loading, error] as const;
};
